import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import QuoteForm from '../../components/base/QuoteForm';
import { useState } from 'react';

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              Get Your <strong>Free Gutter Guard Estimate</strong>
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Contact <strong>NWA Gutter Guards</strong> for professional <strong>gutter protection</strong> in <strong>Fayetteville, Rogers, Bentonville, and Springdale</strong>. We respond quickly with detailed, no-obligation estimates.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
            {/* Contact Information */}
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight">
                Get in Touch
              </h2>

              <div className="space-y-6 sm:space-y-6 mb-8 sm:mb-12">
                <div className="flex items-start">
                  <div className="w-14 h-14 sm:w-14 sm:h-14 flex items-center justify-center bg-green-100 rounded-lg mr-4 sm:mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-2xl sm:text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-lg font-semibold text-gray-900 mb-1">Phone</h3>
                    <a href="tel:479-337-7565" className="text-lg sm:text-lg text-green-600 hover:text-green-700 font-semibold">
                      (479) 337-7565
                    </a>
                    <p className="text-base sm:text-sm text-gray-600 mt-1">Monday - Saturday: 8am - 6pm</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-14 h-14 sm:w-14 sm:h-14 flex items-center justify-center bg-green-100 rounded-lg mr-4 sm:mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-2xl sm:text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-lg font-semibold text-gray-900 mb-1">Email</h3>
                    <a href="mailto:info@nwagutterguards.com" className="text-base sm:text-lg text-green-600 hover:text-green-700 break-all">
                      info@nwagutterguards.com
                    </a>
                    <p className="text-base sm:text-sm text-gray-600 mt-1">We respond within 24 hours</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-14 h-14 sm:w-14 sm:h-14 flex items-center justify-center bg-green-100 rounded-lg mr-4 sm:mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl sm:text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-lg font-semibold text-gray-900 mb-1">Service Area</h3>
                    <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                      <strong>Fayetteville, Rogers, Bentonville, Springdale</strong><br />
                      and surrounding <strong>Northwest Arkansas</strong> communities
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6 sm:p-6 border-l-4 border-green-600">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                  <i className="ri-time-line text-green-600 mr-2"></i>
                  Fast Response Time
                </h3>
                <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                  Most estimates are provided within 24-48 hours. For urgent needs, we offer same-day service appointments.
                </p>
              </div>
            </div>

            {/* Quote Form */}
            <div className="bg-gray-50 rounded-lg p-6 sm:p-8">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Request Your Free Estimate
              </h2>
              <QuoteForm />
            </div>
          </div>
        </div>
      </section>

      {/* What to Expect */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              What to Expect When You Contact Us
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-green-600 to-green-700 text-white rounded-full mx-auto mb-4 sm:mb-4 text-2xl sm:text-2xl font-bold shadow-lg">
                1
              </div>
              <h3 className="text-lg sm:text-lg font-bold text-gray-900 mb-2">Quick Response</h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We'll contact you within 24 hours to discuss your needs and schedule a site visit.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-green-600 to-green-700 text-white rounded-full mx-auto mb-4 sm:mb-4 text-2xl sm:text-2xl font-bold shadow-lg">
                2
              </div>
              <h3 className="text-lg sm:text-lg font-bold text-gray-900 mb-2">Free Inspection</h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We'll visit your home to assess your gutters and recommend the best solution.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-green-600 to-green-700 text-white rounded-full mx-auto mb-4 sm:mb-4 text-2xl sm:text-2xl font-bold shadow-lg">
                3
              </div>
              <h3 className="text-lg sm:text-lg font-bold text-gray-900 mb-2">Detailed Estimate</h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                You'll receive a comprehensive quote with transparent pricing and no hidden fees.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-green-600 to-green-700 text-white rounded-full mx-auto mb-4 sm:mb-4 text-2xl sm:text-2xl font-bold shadow-lg">
                4
              </div>
              <h3 className="text-lg sm:text-lg font-bold text-gray-900 mb-2">Professional Install</h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Once approved, we'll schedule your installation at your convenience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Service */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto bg-gradient-to-br from-red-50 to-orange-50 border-2 border-red-200 rounded-lg p-6 sm:p-8 text-center">
            <div className="w-16 h-16 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-red-500 to-red-600 text-white rounded-full mx-auto mb-4 sm:mb-4 shadow-lg">
              <i className="ri-alert-line text-3xl sm:text-3xl"></i>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Need Emergency <strong>Gutter Service</strong>?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-6 leading-relaxed">
              If you're experiencing gutter overflow, water damage, or need immediate assistance, call us now for same-day service.
            </p>
            <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-red-500 to-red-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-red-600 hover:to-red-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
              <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565 Now
            </a>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Find Us in <strong>Northwest Arkansas</strong>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
              Proudly serving Fayetteville, Rogers, Bentonville, Springdale, and surrounding areas
            </p>
          </div>

          <div className="rounded-lg overflow-hidden shadow-xl">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207134.6!2d-94.17!3d36.08!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87c96f7b0f3f3f3f%3A0x3f3f3f3f3f3f3f3f!2sNorthwest%20Arkansas!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="NWA Gutter Guards service area map"
              className="sm:h-[450px]"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Why Choose <strong>NWA Gutter Guards</strong>?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                <i className="ri-time-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Fast Response</h3>
              <p className="text-base text-gray-600 leading-relaxed">
                We respond to all inquiries within 24 hours and offer same-week installation for most projects.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Transparent Pricing</h3>
              <p className="text-base text-gray-600 mb-4 leading-relaxed">No hidden fees or surprise charges. Get a detailed <strong>free estimate</strong> with clear pricing upfront.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Lifetime Warranty</h3>
              <p className="text-base text-gray-600 leading-relaxed">
                All <strong>stone coated gutter cap</strong> installations come with our comprehensive lifetime warranty.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5jbvnhugl990ce152vg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          address: '',
          city: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="John Smith"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="john@example.com"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="(479) 337-7565"
          />
        </div>
        <div>
          <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">City *</label>
          <select
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
            className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          >
            <option value="">Select City</option>
            <option value="Fayetteville">Fayetteville</option>
            <option value="Springdale">Springdale</option>
            <option value="Rogers">Rogers</option>
            <option value="Bentonville">Bentonville</option>
            <option value="Bella Vista">Bella Vista</option>
            <option value="Siloam Springs">Siloam Springs</option>
            <option value="Other">Other NWA Area</option>
          </select>
        </div>
      </div>

      <div>
        <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">Street Address</label>
        <input
          type="text"
          id="address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          placeholder="123 Main Street"
        />
      </div>

      <div>
        <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1">Service Needed *</label>
        <select
          id="service"
          name="service"
          value={formData.service}
          onChange={handleChange}
          required
          className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
        >
          <option value="">Select Service</option>
          <option value="Stone Coated Gutter Cap Installation">Stone Coated Gutter Cap Installation</option>
          <option value="Gutter Guard Installation">Gutter Guard Installation</option>
          <option value="Seamless Gutters">Seamless Gutters</option>
          <option value="Gutter Cleaning">Gutter Cleaning</option>
          <option value="Gutter Repair">Gutter Repair</option>
          <option value="French Drains">French Drains</option>
          <option value="Free Estimate">Free Estimate</option>
        </select>
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Additional Details</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows={4}
          maxLength={500}
          className="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
          placeholder="Tell us about your project..."
        ></textarea>
        <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
      </div>

      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap"
      >
        {isSubmitting ? 'Sending...' : 'Send Message'}
      </button>

      {submitStatus === 'success' && (
        <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
          Thank you! We'll contact you within 24 hours.
        </div>
      )}

      {submitStatus === 'error' && (
        <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
          Something went wrong. Please call us at (479) 337-7565.
        </div>
      )}
    </form>
  );
};

export default ContactPage;
